export default [{
    "catalogId": "10",
    "name": "数字化种植修复",
    "icon": "/static/images/order/catalog/10.png",
    "iconSelect": "/static/images/order/catalog/10_select_1.png",
    "subCataLog": [{
        "subCatalogId": "1010120",
        "name": "种植上部修复冠",
        "icon": "/static/images/order/catalog_sub/10_101_20.png"
      },
      {
        "subCatalogId": "1010698",
        "name": "导板（牙支持式）",
        "icon": "/static/images/order/catalog_sub/10_106_98.png"
      }, {
        "subCatalogId": "1010699",
        "name": "导板（无牙颌）",
        "icon": "/static/images/order/catalog_sub/10_106_99.png"
      },
      {
        "subCatalogId": "1010700",
        "name": "放射导板",
        "icon": "/static/images/order/catalog_sub/10_106_100.jpg"
      }
      ,{
        "subCatalogId": "1010210",
        "name": "基台设计（金属）",
        "icon": "/static/images/order/catalog_sub/10_102_10.png"
      }, {
        "subCatalogId": "1010220",
        "name": "基台设计（全瓷）",
        "icon": "/static/images/order/catalog_sub/10_102_20.png"
      },
      {
        "subCatalogId": "1010310",
        "name": "基台一体冠（金属）",
        "icon": "/static/images/order/catalog_sub/10_103_10.png"
      },
      {
        "subCatalogId": "1010320",
        "name": "基台一体冠（全瓷）",
        "icon": "/static/images/order/catalog_sub/10_103_20.png"
      },
      {
        "subCatalogId": "1010410",
        "name": "马泷桥",
        "icon": "/static/images/order/catalog_sub/10_104_10.png"
      }, {
        "subCatalogId": "1010510",
        "name": "杆卡",
        "icon": "/static/images/order/catalog_sub/10_105_10.png"
      },
    ]
  },
  {
    "catalogId": "20",
    "name": "数字化固定修复",
    "icon": "/static/images/order/catalog/20.png",
    "iconSelect": "/static/images/order/catalog/20_select_1.png",
    "subCataLog": [{
        "subCatalogId": "2010120",
        "name": "氧化锆全冠",
        "icon": "/static/images/order/catalog_sub/20_101_20.png"
      }, {
        "subCatalogId": "2010210",
        "name": "烤瓷冠（内冠-金属）",
        "icon": "/static/images/order/catalog_sub/20_102_10.png"
      },
      {
        "subCatalogId": "2010220",
        "name": "烤瓷冠（内冠-氧化锆）",
        "icon": "/static/images/order/catalog_sub/20_102_20.png"
      },
      {
        "subCatalogId": "2010320",
        "name": "玻璃陶瓷嵌体/冠",
        "icon": "/static/images/order/catalog_sub/20_103_20.png"
      }, {
        "subCatalogId": "2010420",
        "name": "玻璃陶瓷贴面",
        "icon": "/static/images/order/catalog_sub/20_104_20.png"
      }
    ]
  },
  {
    "catalogId": "30",
    "name": "数字化正畸修复",
    "icon": "/static/images/order/catalog/30.png",
    "iconSelect": "/static/images/order/catalog/30_select_1.png",
    "subCataLog": [{
      "subCatalogId": "3010130",
      "name": "隐形矫治",
      "icon": "/static/images/order/catalog_sub/30_101_30.png"
    }]
  },
  {
    "catalogId": "40",
    "name": "数字化活动修复",
    "icon": "/static/images/order/catalog/40.png",
    "iconSelect": "/static/images/order/catalog/40_select_1.png",
    "subCataLog": [ {
      "subCatalogId": "4010110",
      "name": "可摘局部义齿",
      "icon": "/static/images/order/catalog_sub/40_101_10.png"
    },
    {
      "subCatalogId": "4010120",
      "name": "全口活动总义齿",
      "icon": "/static/images/order/catalog_sub/40_101_20.png"
    }
  ]
  }
]



// WEBPACK FOOTER //
// ./src/assets/config/order/catalogList.js